import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Guards the /projects page and every project detail route.
 *
 * Back-office roles (Staff, Procurement HO, Operational, Finance, Accounting)
 * can see all projects on the dashboard but must NOT open the /projects page
 * or a project's detail page. They are redirected to the dashboard.
 *
 * Keep BACK_OFFICE_ROLES in sync with the backend permission matrix
 * (backend/src/auth/roles.js -> BACK_OFFICE_ROLES).
 */
const BACK_OFFICE_ROLES = [
  'staff',
  'procurement_ho_manager', 'procurement_ho_staff',
  'operational_manager', 'operational_staff',
  'finance_manager', 'finance_staff',
  'accounting',
  'gs',
];

const ProjectsRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const role = (user?.role || '').toLowerCase();
  if (BACK_OFFICE_ROLES.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProjectsRoute;
